<template>
    <b-col class="form-control mt-3 p-3">
        <b-overlay :show="loading" rounded="sm">
            <b-form @submit.stop.prevent="onSubmit">
                <label class='mb-2'><strong>{{title}}</strong></label>
                <b-col class="mt-3">
                    <label class="mb-3"><strong> {{$nameLabel()}}</strong><span class="red">*</span></label>
                    <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()"  v-model="model.name" required :placeholder="$translate('enter_name')"
                        trim></b-form-input>
                </b-col>
                <b-col class="mt-3">
                    <label class="mb-3"><strong>{{$translate('description')}}</strong></label>
                    <b-form-input type="text" id="input-description" v-model="model.description" :placeholder="$translate('enter_description')"
                        trim></b-form-input>
                </b-col>
                <b-col cols="12" class="my-3">
                    <b-col class="form-group">
                        <b-col class="form-check">
                            <label class="form-check-label">
                                <input type="checkbox" v-model="model.is_default" name="input-is_default"
                                    class="form-check-input"><i class="input-helper"></i><span class="ml-3">{{$translate('default')}}</span><span                                class="red">*</span></label>
                        </b-col>
                    </b-col>
                </b-col>
                <b-col cols="12" class="mb-2 mt-4 text-center">
                    <b-button id="create-add-field-btn" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                        :disabled="loading ? true : false" v-if="hasPermissionCreate && !model.id">{{ createLabel
                        }}</b-button>
                        <b-button id="update-add-field-btn" type="submit" class="btn btn-info btn-fw me-2" variant="primary"
                        :disabled="loading ? true : false" v-if="hasPermissionUpdate && model.id">{{ updateLabel
                        }}</b-button>

                    <b-button id="delete-add-field-btn" v-if="this.model.id && hasPermissionDelete  " @click="deleteItem()" size="fw" variant="delete-button" class="me-2">
                        {{ $deleteLabel() }}
                    </b-button>
                    <b-button id="cancel-add-field-btn" variant="info" :disabled="loading ? true : false" @click="cancel()"
                        class="btn-fw">{{ $cancelLabel() }}</b-button>
                </b-col>
            </b-form>
        </b-overlay>
    </b-col>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'additionalFields-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                // type: 2,
                module_for: 1,
                field_type: 2,
                label: null,
                name: null,
                is_default: false,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item','title'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        // submitLabel() {
        //     if (this.loading && this.model.id) {
        //         return 'Updating...'
        //     } else if (this.loading) {
        //         return 'Creating...'
        //     } else if (this.model.id) {
        //         return 'Update'
        //     } else {
        //         return 'Create'
        //     }
        // },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            if (!model.description) model.description = '-'
            console.log('model', model)
            const action = model.id
                ? 'updateAdditionalFieldItem'
                : 'createAdditionalFieldItem'
            const path = `additionalField/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                model.id ? 'updated' : 'created'
                                // `${
                                //     action.charAt(0).toUpperCase() +
                                //     action.slice(1)
                                // }d`
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'additionalField/delete'
            // const action = model.id ? 'update' : 'create'
            
            // Generate and display confirmation prompt
            const title = `${this.$translate('delete')} ${this.$translate('additional_field')}?`
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = this.$translate('unable_alert')
            const alertMsg = this.$translate('delete_alert')

            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit(
                                'success',
                                this.$translate('deleted'),
                                alertMsg
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })
            // this.$emit(
            //     'delete-item',
            //     title,
            //     message,
            //     model.id,
            //     () => {
            //         this.$emit('success', this.$translate('deleted'))
            //     },
            //     path,
            //     errorMsg
            // )
        },
    },
}
</script>
<style></style>
